import React from "react";
import moment from "moment";
import { connect } from "react-redux";

import { movil } from "../../app-movil";
import { nombreProductoGM, getNumPoliza } from "../../common/logica";
import { authentication, database, logOut, fbDbRefs } from "../../app-database";
import { savePhotoToBucketKmFinal } from './pagoPorKilometro.act'
import { String } from "es6-shim";

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Card, CardMedia } from 'material-ui/Card';
import TextFiled from 'material-ui/TextField';
import Modal from '../../generalcomponets/modal-mobile';
import { Field } from "redux-form";

const mapState = (state) => {
	return {
		"loading": state.global.loading,
		// "poliza": state.polizas.poliza,
		"ts": state.polizas.ts,
		"callTs": state.polizas.callTs,
		"timeout": state.polizas.inactividad,
		// "pagoPorKM": state.polizas.pagoPorKilometro,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		cerrarDetalle: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		actualizaTouchId: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });  
		},
		descargarCertificado: (sPoliza, sCertificado) => {
			dispatch(descargarCertificadoAzul(sPoliza, sCertificado, true));
		},
		regresar: () => {
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		descargarDocumento: (sDocumento, sPoliza, sVersion, sRecibo, bMovil) => {
			dispatch(descargarDocumento(sDocumento, sPoliza, sVersion, sRecibo, bMovil));
		},
		mostrarErrorSesion: () => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": "Has excedido el tiempo de visualización de la póliza. Para poder acceder a ella se te solicitará verificar tu identidad." });
		},
		reloadData: (poliza, version) => {

		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};
//const cameraPlaceholderOdo = require("../../img/odometro.png");
const cameraPlaceholderVin = require("../../img/dbk_reg_km_init.png");


const campoSettings = {
	fontFamily:'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings={
		...campoSettings,
		lineHeight: '24px',
		letterSpacing: '0.5px',
		color: '#0C2040',
		zIndex: 0
}

const floatingLabelFocusStyleSettings={
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#647085',
}

class ConsultaKmFinal extends React.Component {

	state = {
		'kmIni': '',
		'kmFin': '',
        consultaKmFinal: cameraPlaceholderVin,
        consultaKmInicial: cameraPlaceholderVin,
        diferenciaKilometros: '',
		porcentajeCupon: '0',
		fechaVigenciaCupon:'',
        // ----------------------estados de la parte de consulta
		// "needSubmit1": false,
		// "supDer": cameraPlaceholder2,
		// "supIzq": cameraPlaceholder1,
		// "infDer": cameraPlaceholder3,
		// "infIzq": cameraPlaceholder4,
		// "vin": cameraPlaceholderVin,
		// "supDerEnabled": true,
		// "supIzqEnabled": true,
		// "infDerEnabled": true,
		// "infIzqEnabled": true,
		// "vinEnabled": true,
		// "supDerSubmit": false,
		// "supIzqSubmit": false,
		// "infDerSubmit": false,
		// "infIzqSubmit": false,
		// "vinSubmit": false,
		source: "",
		startCamera: true,
		endCamera: false,
		disableSendButton: true,
		enableTextBox: false,
		enableEndTextBox: false,
		startCameraEnabled: false,
		endCameraEnabled: false,
		disableFirstSection: false,
		disableSecondSection: true,
		infDerFilled: false,
		infIzqFilled:false,
		supDerFilled:false,
		supIzqFilled: false,
		vinFilled: false,
		filledStart: false,
		siCupon: false,
		isActiveModalError: false,
	}

	cargarImagen = (sImagen) => {
		var state = {};
		state[sImagen] = true;
		this.setState(state);
	}

	mostrarPantalla = () => {
		if ( !this.state.cargaCompleta ) {
			var _this = this;
			var ini = moment(this.props.appParams.fchVigenciaInicial, "DD/MM/YYYY").valueOf();
			var fin = moment(this.props.appParams.fchVigenciaFinal, "DD/MM/YYYY").valueOf();
			var now = moment().valueOf();

			var color = "#183D7B", vigencia = "90%";

			if (now > fin) {
				color = "#FF6F20";
				vigencia = "100%";
			}

			if (now < fin) {
				vigencia = (((now - ini) * 100) / (fin - ini)) + "%";
			}

			setTimeout(() => {
				$(".contenedor-detalle").addClass("contenedor-detalle-visible");
			}, 300);
			setTimeout(() => {
				$(".detalle-poliza").addClass("detalle-poliza-visible");
			}, 500);
			setTimeout(() => {
				$(".titulo-detalle").addClass("titulo-detalle-visible");
			}, 700);
			setTimeout(() => {
				$(".botones-detalle").addClass("botones-detalle-visible");
			}, 900);
			setTimeout(() => {
				_this.setState({ "vigencia": vigencia, "colorVigencia": color, "cargaCompleta": true });
				_this.props.actualizaTouchId();
			}, 1200);
		}
	}

	validaInactividad = () => {
		if (new Date() > new Date(this.props.callTs + this.props.timeout)) {
			this.props.mostrarErrorSesion();
			this.props.regresar();
			let mensaje = {"return": "home"};
			movil("", mensaje);
			return false;
		} else {
			this.props.actualizaTouchId();
			return true;
		}
	}

	obtenerFechaLimiteInicio = () => {
		moment().locale('es');
		var date = moment(this.props.appParams.fchVigenciaInicial, 'DD/MM/YYYY').add(14, 'days').format('L');		
		return date;
	}

	obtenerFechaLimiteTermino = () => {
		moment().locale('es');
		var date = moment(this.props.appParams.fchVigenciaFinal, 'DD/MM/YYYY').subtract(30, 'days').format('L');
		return date;
	}

	regresar = () =>{
		this.props.regresar();
		let mensaje = {"return": "home"};
		movil("", mensaje);
	}

	getDeviceType(){
		if(typeof window.webkit != 'undefined' && window.webkit.messageHandlers) return "iOS";
		if(typeof android_conectam != 'undefined') return "android";
		return "browser";

	}

	activateCameraByDeviceType(payload){
		switch(this.getDeviceType()){
			case 'iOS':
				window.webkit.messageHandlers.callbackHandler.postMessage(payload);
			break;

			case 'android':
				android_conectam.callbackHandler(JSON.stringify(payload.error), JSON.stringify(payload.data));
			break;
		}
	}

	// takePhoto(source, enabled){
	// 	console.log('source',source);
	// 	if(!enabled) return;
	// 	var payload = {
	// 		"data": {
	// 			"proceso": "camara",
	// 			"return": "savePhoto()"
	// 		},
	// 		"error": "errorHandler"
	// 	};
	// 	this.setState({
	// 		source: source
	// 	});
	// 	this.activateCameraByDeviceType(payload);
	// }

	componentDidMount(){
		let { appParams } = this.props;
		if( appParams ){
            this.setState({
                kmFin: appParams.endKm,
                kmIni: appParams.startKm,
                consultaKmInicial: appParams.startPhoto,
                consultaKmFinal: appParams.endPhoto,
				diferenciaKilometros: appParams.endKm - appParams.startKm,
				siCupon: appParams.cupon ? true: false,
				porcentajeCupon: appParams.cupon && appParams.cuponPorcentaje ? appParams.cuponPorcentaje : '',
				fechaVigenciaCupon: appParams.cupon && appParams.cuponFechaVigencia ? appParams.cuponFechaVigencia : '',
				monto: appParams.cupon && appParams.cuponMonto ? appParams.cuponMonto : ''
            });
		}
	}

    
	// validarEnviar(key,photos){
	// 	if(this.state[key+"Submit"]){
	// 		photos.push({
	// 			poliza:this.props.poliza.generales.numPoliza, 
	// 			version: this.props.poliza.generales.numVersion, 
	// 			km: 0, 
	// 			type: key, 
	// 			photo: this.state[key]
	// 		});
	// 	}
	// 	return this.state[key +"Filled"];
	// }

	// kmFin(e){
	// 	if(e.target.value.length <= 7){
	// 		if( this.state.camara1Photo !== cameraPlaceholderOdo && this.state.kmfin !== '' ){
	// 			this.setState({disableSendButton:false});
	// 		}
	// 		this.setState({
	// 			kmFin: e.target.value.replace(',', '').replace(/[^\d,]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ","),
	// 		});
	// 	}
	// }

	ShowConfirmationModal(){
		//$('#modal-confirmacion').modal('show');
		//this.closeModalRegistroFromChild();
		let mensaje = {"return": "home"};
		movil("", mensaje);
	}
	closeModalRegistroFromChild = () => {
		this.setState({ isActiveModalRegistro: false})
	}

	aceptar() {
		this.props.tagManager({
			dispositivo: this.props.dispositivo,
			type: 'EVENT_CLICK_ENVIAR-PAGO-POR-KM-' + this.state.source.toUpperCase()
		});

		$('#modal-registro').modal('hide');
		let mensaje = {"return": "home"};
		movil("", mensaje);
		// window.location.reload(true);
	}
	aceptarError() {
		this.closeModalErrorFromChild();
	}
	
	aceptarAutorizador(){
		$('#modal-autorizador').modal('hide');
		let mensaje = {"return": "home"};
		movil("", mensaje);
		window.location.reload(true);
	}
	volver(){

		$('#modal-confirmacion').modal('hide');

	}
	openModalErrorParent = () => {
		let { isActiveModalError } = this.state;

		if(isActiveModalError)
		  this.setState({ isActiveModalError: false})
		else{
		  this.setState({ isActiveModalError: true});
		}
	}

	closeModalErrorFromChild = () => {
		this.setState({ isActiveModalError: false})
	}

	render() {
		this.mostrarPantalla();

		return(
			<MuiThemeProvider>
			<div id="dbk-pago-por-km" className="polizas-mobile">
					<div className="modal-dialog" role="document">
								{	this.state.isActiveModalError &&
									<Modal closeModalFromChild={() => null}>
											<div className="container">
											<div className="row">
											<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
													<label className="gnp-material-title-modal">Error al realizar el registro</label>
												</div>
												<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
													<p className=" gnp-material-content-modal">Servicio no disponible, por favor intente más tarde.</p>
												</div>
												<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
													<button type="button" onClick={this.aceptarError.bind(this)} className="pure-material-button-contained btn-full-width">Aceptar</button>
												</div>
											</div>
										</div>
									</Modal>
								}
					</div>
				<div className="container">
					<div className="box-wrap">
						<div className="cards-wrap mt-25 contenedor-detalle">
							<div className="row">
								<div aria-hidden="false">
										<div className="col-xs-2">
											<img className="smart-trip-img-size" src={require('../../img/smart-trip.png')} />
										</div>
										<div className="col-xs-8">
											<p>
												<b id="title-dbk-ph1">Distintivo bajo kilometraje</b>
											</p>
										</div>
                                    <div className="row">
                                        <div className="col-xs-12 elements-width">
												<p className="text-center text-contened captura-fotos-serie" >
													Kilometraje inicial
												</p>
												<div className="text-center consulta-km-fin-labels">
												<TextFiled 
														name="consultaKmInicial"
														value={Intl.NumberFormat('en-mx').format(this.state.kmIni)} 
														type="tel" 
														pattern="[0-9]*" 
														noValidate 
														id="camera-start"  
														underlineStyle={{borderColor: '#FFFFFF'}}
														underlineFocusStyle={{borderColor: '#FFFFFF'}}
														floatingLabelStyle={floatingLabelStyleSettings}
														floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
														/>	
												</div>
												<div className="col-xs-6 image-cards-centerM2">
													<Card className="height-card-filled">
														<div>
															<img  className="image-filled" src={this.state.consultaKmInicial}  style={{ paddingLeft: this.state.consultaKmInicial !== cameraPlaceholderVin ? '': ''}}/>
															<div >
																	<p className="text-center text-contened captura-fotos-serie" >
																		Kilometraje inicial
																	</p>
															</div>	
														</div>
													</Card>
												</div>
                                        </div>
													<div className="col-xs-12 elements-width">
															<p className="text-center text-contened captura-fotos-serie" >
																Kilometraje final
															</p>
															<div className="text-center consulta-km-fin-labels">
																<TextFiled
																			name="consultaKmFinal"
																			value={Intl.NumberFormat('en-mx').format(this.state.kmFin)} 
																			type="tel" 
																			pattern="[0-9]*" 
																			noValidate 
																			id="camera-end"
																			underlineStyle={{borderColor: '#FFFFFF'}}
																			underlineFocusStyle={{borderColor: '#FFFFFF'}}
																			floatingLabelStyle={floatingLabelStyleSettings}
																			floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
																		  />	
															</div>	
																			
														<div className="col-xs-6 image-cards-centerM2">
															<Card className="height-card-filled">
																<div >
																	<img className="image-filled" src={this.state.consultaKmFinal} style={{ paddingLeft: this.state.consultaKmFinal !== cameraPlaceholderVin ? '': ''}}/>
																	<div>
																			<p className=" text-center text-contened captura-fotos-serie" >
																				Kilometraje final
																			</p>
																	</div>	
																</div>
															</Card>
														</div>
													</div>
                                    </div>
										<div className="col-xs-12 elements-width">
											<p className="text-center text-contened captura-fotos-serie" >
												Kilómetros recorridos durante tu vigencia:
											</p>
										</div>
										<p className="text-center" style={{fontSize:"16px", fontWeight:"bold", color:"#0C2040"}}>
										{Intl.NumberFormat('en-mx').format(this.state.diferenciaKilometros)} 
										</p>
                                    <div className="row">
										{
											this.state.siCupon
											?
											<div className="col-xs-12 text-justify text-contened">
												<p style={{/*fontSize:"14px"*/}}>
													Felicidades, obtuviste una bonificación del <strong style={{fontWeight:'bold', color:'#1f3f79'}}>{this.state.porcentajeCupon}%</strong> de tu prima neta,
													que equivale a:
												</p>
												<p 
												className="text-center text-contened"
												style={{/*fontSize:"16px", fontWeight:"normal", color:"#1f3f79"*/}}>
													<strong>{this.state.monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} pesos</strong>
												</p>
												<p 
												className="text-center text-contened"
												style={{/*fontSize:"14px"*/}}>
													Tu código de bonificación es válido hasta: <strong style={{color:"#1f3f79"}}>{this.state.fechaVigenciaCupon}</strong>
												</p>
												<p 
												className="text-justify text-contened"
												style={{/*fontSize:"14px", color:"#1f3f79"*/}}>
												{/*	<img
													style={{/*display:"inline-block", width:"25px"}}
													className="img-responsive center-block text-contened"
													src={require('../../img/beneficios-soy-cliente.svg')} />*/}
													Consulta tu código y los detalles de cómo utilizarlo  en la sección 
													Beneficios Soy Cliente GNP.
												</p>
											</div>
											:
											<div className="col-xs-12 text-justify text-contened captura-fotos-serie">
												<p>
													En ésta ocasión recorriste más de los 7,000 kilómetros que reconoce 
													el beneficio de Distintivo bajo kilometraje GNP. Te invitamos a inscribirte 
													de nuevo al beneficio y ser un Conductor Ecológico.
												</p>
											</div>
										}
                                    </div>
									<div className="row">
									<div className="col-xs-12 elements-width button-siguiente">
										<button  onClick={this.ShowConfirmationModal.bind(this)} id="send-button" type="button" className="pure-material-button-contained btn-full-width">Aceptar</button>
									</div>
									</div>

								</div>	
							</div>
						</div>
					</div>
				</div>
			</div>
		</MuiThemeProvider>	
		);
	}
}

export default connect(mapState, mapDispatch)(ConsultaKmFinal);


// WEBPACK FOOTER //
// ./src/movil/polizas/consultaKmFinal.cmpt.js